<template>
  <v-container>
    <v-row class="text-center my-5">
      <v-col class="mb-5" cols="12">
        <v-card>
          <v-toolbar color="secondary" class="elevation-0">
            <v-toolbar-title> Tenant - {{ tenant?.name }} </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <v-col col="12" lg="6">
                <v-row>
                  <v-col cols="4" align="start">
                    <v-icon class="mr-3">mdi-identifier</v-icon>
                    <strong>UID</strong>
                  </v-col>
                  <v-col align="start">
                    {{ tenant?.uid }}
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="4" align="start">
                    <v-icon class="mr-3">mdi-label</v-icon>
                    <strong>Name</strong>
                  </v-col>
                  <v-col align="start">
                    {{ tenant?.name }}
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="4" align="start">
                    <v-icon class="mr-3">mdi-at</v-icon>
                    <strong>Email</strong>
                  </v-col>
                  <v-col align="start">
                    {{ tenant?.email_address }}
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="4" align="start">
                    <v-icon class="mr-3">mdi-phone</v-icon>
                    <strong>Phone</strong>
                  </v-col>
                  <v-col align="start">
                    {{ tenant?.phone_number }}
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="4" align="start">
                    <v-icon class="mr-3">mdi-lightbulb-on</v-icon>
                    <strong>Activated</strong>
                  </v-col>
                  <v-col align="start">
                    <span v-if="tenant?.activated_at">
                      {{ new Date(tenant?.activated_at).toLocaleDateString() }}
                    </span>
                    <v-icon v-if="!tenant?.activated_at">mdi-close</v-icon>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="4" align="start">
                    <v-icon class="mr-3">mdi-plus</v-icon>
                    <strong>Created</strong>
                  </v-col>
                  <v-col align="start">
                    {{ new Date(tenant?.created_at).toLocaleDateString() }}
                  </v-col>
                </v-row>
              </v-col>

              <v-col col="12" lg="6">
                <v-row justify="center">
                  <v-col align="start">
                    <v-expansion-panels accordion flat>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          <span>
                            <v-icon class="mr-2">mdi-map-marker</v-icon>
                            Shipping Address
                          </span>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-row>
                            <v-col align="start">
                              <v-icon class="mr-2">mdi-earth</v-icon>
                              <strong>Country</strong>
                            </v-col>
                            <v-col align="start">
                              {{ tenant?.shipping_country }}
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col align="start">
                              <v-icon class="mr-2">mdi-office-building</v-icon>
                              <strong>Address</strong>
                            </v-col>
                            <v-col align="start">
                              {{ tenant?.shipping_address_1 }}
                              {{ tenant?.shipping_address_2 }}
                            </v-col>
                          </v-row>

                          <v-row>
                            <v-col align="start">
                              <v-icon class="mr-2">mdi-home-group</v-icon>
                              <strong>Suburb</strong>
                            </v-col>
                            <v-col align="start">
                              {{ tenant?.shipping_suburb }}
                            </v-col>
                          </v-row>

                          <v-row>
                            <v-col align="start">
                              <v-icon class="mr-2">mdi-map-marker</v-icon>
                              <strong>State</strong>
                            </v-col>
                            <v-col align="start">
                              {{ tenant?.shipping_state }}
                            </v-col>
                          </v-row>

                          <v-row>
                            <v-col align="start">
                              <v-icon class="mr-2">mdi-email</v-icon>
                              <strong>Postal Code</strong>
                            </v-col>
                            <v-col align="start">
                              {{ tenant?.shipping_postal_code }}
                            </v-col>
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>

                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          <span>
                            <v-icon class="mr-2">mdi-map-marker-outline</v-icon>
                            Billing Address
                          </span>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-row>
                            <v-col align="start">
                              <v-icon class="mr-2">mdi-earth</v-icon>
                              <strong>Country</strong>
                            </v-col>
                            <v-col align="start">
                              {{ tenant?.billing_country }}
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col align="start">
                              <v-icon class="mr-2">mdi-office-building</v-icon>
                              <strong>Address</strong>
                            </v-col>
                            <v-col align="start">
                              {{ tenant?.billing_address_1 }}
                              {{ tenant?.billing_address_2 }}
                            </v-col>
                          </v-row>

                          <v-row>
                            <v-col align="start">
                              <v-icon class="mr-2">mdi-home-group</v-icon>
                              <strong>Suburb</strong>
                            </v-col>
                            <v-col align="start">
                              {{ tenant?.billing_suburb }}
                            </v-col>
                          </v-row>

                          <v-row>
                            <v-col align="start">
                              <v-icon class="mr-2">mdi-map-marker</v-icon>
                              <strong>State</strong>
                            </v-col>
                            <v-col align="start">
                              {{ tenant?.billing_state }}
                            </v-col>
                          </v-row>

                          <v-row>
                            <v-col align="start">
                              <v-icon class="mr-2">mdi-email</v-icon>
                              <strong>Postal Code</strong>
                            </v-col>
                            <v-col align="start">
                              {{ tenant?.billing_postal_code }}
                            </v-col>
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col class="mb-5" cols="12">
        <SubscriptionsCard :tenant_uid="this.$route.params.uid" />
      </v-col>

      <v-col class="mb-5" cols="12">
        <PlansCard :tenant_uid="this.$route.params.uid" />
      </v-col>

      <v-col class="mb-5" cols="12" xl="6">
        <QuotasCard :tenant_uid="this.$route.params.uid" />
      </v-col>


      <v-col class="mb-5" cols="12" xl="6">
        <QuotaAggregate :tenant_uid="this.$route.params.uid" />
      </v-col>

      <v-col class="mb-5" cols="12">
        <LedgerCard :tenant_uid="this.$route.params.uid" />
      </v-col>

      <v-col class="mb-5" cols="12">
        <InvoicesCard :tenant_uid="this.$route.params.uid" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SubscriptionsCard from "../Categories/SubscriptionsCard.vue";
import QuotasCard from "../Categories/QuotasCard.vue";
import LedgerCard from "../Categories/LedgerCard.vue";
import InvoicesCard from "../Categories/InvoicesCard.vue";
import QuotaAggregate from "../Aggregates/QuotaAggregate.vue";
import PlansCard from "../Categories/PlansCard.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    SubscriptionsCard,
    QuotasCard,
    QuotaAggregate,
    LedgerCard,
    InvoicesCard,
    PlansCard
  },
  data: () => ({}),

  computed: {
    ...mapGetters(["tenants"]),
    tenant() {
      return this.tenants?.find((t) => t.uid === this.$route.params.uid);
    },
  },

  beforeMount() {
    if (!this.$route.params.uid) this.$router.push("/");
  },
};
</script>
